import { render } from "./BaseErrorList.vue?vue&type=template&id=0e9ef811"
import script from "./BaseErrorList.vue?vue&type=script&lang=js"
export * from "./BaseErrorList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__